const createState = () => ({
  isSendingRequest: false
})

export function START_SENDING_REQUEST (state) {
  state.isSendingRequest = true
}
export function FINISH_SENDING_REQUEST (state) {
  state.isSendingRequest = false
}

const createMutations = () => ({
  START_SENDING_REQUEST,
  FINISH_SENDING_REQUEST
})

export const vuexSendingRequestBase = {
  createState,
  createMutations
}
